<dx-popup
  #dlgTerminalSelection
  [width]="450"
  [height]="400"
  [showTitle]="true"
  title="Register Terminal"
  [resizeEnabled]="false"
  [dragEnabled]="true"
  [showCloseButton]="false"
  [hideOnOutsideClick]="false"
>
  <dxi-toolbar-item widget="dxButton" toolbar="bottom" location="after" [options]="OKButtonOptions"> </dxi-toolbar-item>
  <dxi-toolbar-item
    *ngIf="showCancel"
    widget="dxButton"
    toolbar="bottom"
    location="after"
    [options]="CancelButtonOptions"
  >
  </dxi-toolbar-item>
  <div *dxTemplate="let data of 'content'">
    <dx-form [formData]="terminalData">
      <dxi-item [colSpan]="2">
        <dxo-label text="Terminal"> </dxo-label>
        <div *dxTemplate>
          <dx-select-box
            displayExpr="Name"
            valueExpr="Id"
            [dataSource]="terminalList"
            (onValueChanged)="onTerminalChanged($event)"
            [(value)]="selectedTerminalId"
          >
          </dx-select-box>
        </div>
      </dxi-item>
      <dxi-item dataField="IPAddress" caption="Unique Id" dataType="string" [editorOptions]="{ readOnly: true }">
      </dxi-item>
      <dxi-item
        dataField="TillConnected"
        caption="Till Drawer Connected"
        dataType="boolean"
        [visible]="AllowTillConnected"
      ></dxi-item>
      <dxi-item
        dataField="TillId"
        dataType="string"
        editorType="dxSelectBox"
        [visible]="AllowTillConnected"
        [editorOptions]="{
          placeholder: 'Select Till Drawer',
          dataSource: tillDrawerLookup,
          valueExpr: 'TillId',
          displayExpr: 'FriendlyName'
        }"
      >
        <dxo-label text="Till Drawer"> </dxo-label>
      </dxi-item>
    </dx-form>
  </div>
</dx-popup>
